import {configureStore} from "@reduxjs/toolkit"
import reducer from "./reducers"


const store = configureStore({
    reducer: reducer,
    //middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger)
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch

export default store
